import { RenderChipProps } from '@/components/core/Games/LastRounds/Chips/props';
import Link from '@/components/core/Link';
import { Image } from '@starsoft/common/components';
import styles from './styles.module.scss';

export default function ForturnDoubleLastRoundsChip({
  round,
  isLoading,
  cover,
  link,
  modal,
}: RenderChipProps) {
  if (isLoading) {
    return (
      <div
        className={`${styles.skeleton} ${cover ? styles['skeleton--cover'] : ''}`}
      />
    );
  }

  return (
    <Link
      modal={modal}
      href={link}
      className={`${styles.link} ${cover ? styles['link--cover'] : ''}`}
    >
      <Image
        className={styles.link__image}
        width={180}
        height={180}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/backgrounds/${round?.roulette?.tile?.type?.image?.split('/')[1]}/card.png`}
        alt={`card Frost ${round?.roulette?.tile?.type?.image?.split('/')[1]}`}
        secondarySkeleton
        bundle
      />

      <Image
        className={styles.link__icon}
        width={150}
        height={150}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/icons/${round?.roulette?.tile?.image}`}
        alt={`icon Frost ${round?.roulette?.tile?.image}`}
        secondarySkeleton
        bundle
      />
    </Link>
  );
}
